<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('AddWorkHourDiary') | ToUppercase">
                <small>{{$t('Name') |ToUppercase}}</small><br>
                <vs-input class="w-full" type="text" name="name" v-model="name"/>

                <vs-upload automatic :action="'/api/excel/workHourDiary/' + reportId" :text="$t('UploadExcel')" limit="1" fileName="file" @on-success="successUpload" @on-error="errorUpload"/>
                
                <div class="mt-6">
                    <vs-button class="mr-2" @click="addWorkHourDiary">{{ $t("Add") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
        },
        data() {
            return {
                name: '',
                reportId : -1,
            };
        },
        methods: {
            addWorkHourDiary() {
                this.$vs.loading();
                const thisIns = this;

                if(this.reportId != -1) {
                    //File is already saved
                    //Call edit report instead of add
                    this.$http.put('/report/' + thisIns.reportId + '?type=workHourDiaryReport', {
                        id: thisIns.reportId,
                        name: thisIns.name
                    }).then(function () {
                        thisIns.$vs.notify({
                            text: "Dnevnih delovnih ur shranjen",
                            color: "success",
                        });
                        thisIns.$router.push('/report/workHourDiary');
                    }).catch(function () {
                        thisIns.$vs.notify({
                            text: "Napaka pri shranjevanju",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                        });
                    }).finally(function () {
                        thisIns.$vs.loading.close();
                    });
                }
                else {
                    //File is not added yet
                    //Call add normaly
                    this.$http.post("/report/add?type=workHourDiaryReport", {
                        name: thisIns.name
                    }).then(function () {
                        thisIns.$vs.notify({
                            text: "Dnevnih delovnih ur shranjen",
                            color: "success",
                        });
                        thisIns.$router.push('/report/workHourDiary');
                    }).catch(function () {
                        thisIns.$vs.notify({
                            text: "Napaka pri shranjevanju",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                        });
                    }).finally(function () {
                        thisIns.$vs.loading.close();
                    });
                }
            },
            successUpload(response) {
                this.reportId = parseInt(response.target.responseText);
                this.$vs.notify({
                    color:'success',
                    text:'Excel uspečno shranjen in PDF generiran'
                })
            },
            errorUpload(response) {
                this.$vs.notify({
                    color:'danger',
                    text: response.target.responseText
                })
            }
        },
        created() {
        },
    };
</script>